import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { SiteConsumer } from '@/context/SiteContext'
import { ToastContainer } from 'react-toastify'

import Header from '@/components/Header'
import GlobalStyle from '@/styles/global.css'
import 'react-toastify/dist/ReactToastify.min.css'

const Layout = ({ children, withHeader = true }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  const contextClass = {
    success: 'bg-azul',
    error: 'bg-rojo',
    info: 'bg-gray-600',
    warning: 'bg-orange-400',
    default: 'bg-black',
    dark: 'bg-white-600 font-gray-300',
  }
  return (
    <SiteConsumer>
      {theme => (
        <>
          <GlobalStyle />
          <div className={`themebg ${theme.dark ? 'dark' : 'light'}`}>
            {withHeader && <Header siteTitle={data.site.siteMetadata.title} />}
            <main>{children}</main>
            <ToastContainer
              toastClassName={({ type }) =>
                contextClass[type || 'default'] +
                ' flex p-1 min-h-10 justify-between rounded overflow-hidden cursor-pointer shadow-md transition duration-300 ease-in-out transform hover:shadow-2xl '
              }
              bodyClassName={() => 'block p-4'}
              autoClose={3000}
            />
          </div>
        </>
      )}
    </SiteConsumer>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
